import { Signal } from './Signal';

/**
 * @public
 */
export function wait(time: number): Promise<void> {
    const {
        resolve,
        promise
    } = new Signal<void>();

    window.setTimeout(() => resolve(), time);

    return promise;
}
